<div class="container login">
    <br />
    <div class="row">
        <div class="col align-center partner-themed">
            <div *ngIf="authenticating" class="login-loading" role="status" aria-live="polite">
                <div class="login-spinner"></div>
                <span>{{ 'Loggar in...' | translate }}</span>
            </div>
            <form *ngIf="!authenticating">
                <img src="/gateway-app/browser/assets/ace-logo-white.png" class="logo" />
                <br />
                <mat-form-field class="fullwidth">
                    <label>{{ 'Användarnamn' | translate }}</label>
                    <input matInput type="text" [(ngModel)]="username" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
                <br />
                <mat-form-field class="fullwidth">
                    <label>{{ 'Lösenord' | translate }}</label>
                    <input matInput type="password" [(ngModel)]="password" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
                <br />
                <button mat-raised-button color="primary" class="fullwidth" (click)="login()">{{ 'Logga in' | translate }}</button>
                <br />
                <div *ngIf="loginFailed">{{ 'Inloggningen misslyckades.' | translate }}</div>
            </form>

        </div>
    </div>
</div>
